import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

// Define the type for the request payload
type TResetPasswordRequest = {
  code: string;
  email: string;
  password: string;
};

async function resetPassword({
  code,
  email,
  password,
}: TResetPasswordRequest): Promise<{ message: string } | undefined | void> {
  try {
    const { data } = await client.post('/auth/reset-password', {
      code,
      email,
      password,
    });

    return data?.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message || 'An error occurred'}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}`);
    }
  }
}

export const useResetPasswordMutation = ({ onSuccess }: { onSuccess?: () => void }) => {
  return useMutation({
    mutationFn: resetPassword,
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
  });
};
